export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 8_00.071745f8.jpg";